import { IFacetResponse } from "shared-services";
import { FacetCategories } from "models";
import {
  IFacetCategoryViewModel,
  IFacetsViewModel,
} from "shared/modules/BasicInfo/models/sectionViewModels";

const FACETS_CATEGORIES_MAPPING: Record<string, string> = {
  [FacetCategories.MembershipBodies]: "memberships",
  [FacetCategories.Nationality]: "nationalities",
  [FacetCategories.Appearance]: "appearances",
  [FacetCategories.EyeColour]: "eyeColors",
  [FacetCategories.HairColour]: "hairColors",
  [FacetCategories.HairLength]: "hairLengths",
  [FacetCategories.FacialHair]: "facialHairs",
  [FacetCategories.VoiceStyle]: "voiceStyle",
  [FacetCategories.BeltNotes]: "beltNotes",
  [FacetCategories.Disability]: "disabilities",
  [FacetCategories.Gender]: "genders",
  [FacetCategories.HeritageAndEthnicity]: "heritageAndEthnicity",
  [FacetCategories.EthnicBackground]: "ethnicBackground",
  [FacetCategories.VisasAndWorkingPermits]: "visasAndPermits",
};

const emptyCategory = (): IFacetCategoryViewModel => ({
  id: 0,
  name: "",
  systemName: "" as FacetCategories,
  maxActiveCount: 0,
  facets: [],
});

const categoryToViewModel = (
  category: IFacetResponse
): IFacetCategoryViewModel => ({
  id: category.id,
  name: category.name,
  systemName: category.systemName as FacetCategories,
  maxActiveCount: category.maxActiveCount,
  facets: category.facetGroups.flatMap((group) => group.facets),
});

export function convertFacetsToView(
  facets: IFacetResponse[]
): IFacetsViewModel {
  return Object.entries(FACETS_CATEGORIES_MAPPING).reduce(
    (acc, [systemName, modelKey]) => {
      const category = facets.find((c) => c.systemName === systemName);
      const viewModel = category
        ? categoryToViewModel(category)
        : emptyCategory();
      const existing = acc[modelKey];

      if (existing?.facets.length) {
        return {
          ...acc,
          [modelKey]: {
            ...existing,
            facets: [...existing.facets, ...viewModel.facets],
          },
        };
      }

      return { ...acc, [modelKey]: viewModel };
    },
    {} as IFacetsViewModel
  );
}
